import {
  AfterViewInit,
  Component,
  Input,
  OnChanges,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { NgIconComponent, provideIcons } from '@ng-icons/core';
import { APP_ICONS } from '../../../icons/icon-provider';

// Thin wrapper that exposes a plain `@Input() name: string`, then drives
// NgIconComponent's `name` setter imperatively. This avoids the Angular 15.2
// template type-checker rejecting property bindings on <ng-icon> whose input
// metadata is produced in Angular 16+ partial-Ivy shape.
@Component({
  selector: 'gs-dash-icon',
  standalone: true,
  imports: [NgIconComponent],
  providers: [provideIcons(APP_ICONS)],
  template: `<ng-icon #icon></ng-icon>`,
  styles: [`:host { display: inline-flex; line-height: 0; }`],
})
export class DashIconComponent implements AfterViewInit, OnChanges {
  @Input() name = '';
  @ViewChild('icon', { static: true }) iconRef!: NgIconComponent;

  ngAfterViewInit() { this.apply(); }
  ngOnChanges(_: SimpleChanges) { this.apply(); }

  private apply() {
    if (this.iconRef && this.name) this.iconRef.name = this.name;
  }
}
